//export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

//export const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== ""
    ? process.env.REACT_APP_API_URL
    : window.location.origin;
